<template>
  <div>
    <Input
      search
      placeholder="搜索年级名称"
      v-model="searchKey"
      @on-search="init"
    />
    <Tree :data="datas" show-checkbox @on-check-change="checkItems"></Tree>
  </div>
</template>
<script>
import $axios from "../../utils/axios";
export default {
  name: "YnGrade",
  data() {
    return {
      searchKey: "",
      config: JSON.parse(localStorage.getItem("config")),
      datas: [],
      selectList: Object.assign([], this.currentList),
    };
  },
  props: {
    currentList: {
      type: Array,
      default() {
        return [];
      },
    },
    studySectionId: {
      type: String,
      default() {
        return "";
      },
    },
  },
  methods: {
    init() {
      $axios({
        baseURL: this.config.basic,
        url: "studySections/grade/byCondition",
        params: {
          studySectionId: this.studySectionId,
          searchKey: this.searchKey,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.datas = res.data;

          if (this.selectList.length > 0) {
            this.datas.forEach((x) => {
              x.children.forEach((b) => {
                var array = this.selectList.find((a) => a.gradeId == b.nodeId);

                if (array != undefined && JSON.stringify(array) != "{}") {
                  console.log(JSON.stringify(array));
                  b.checked = true;
                }
              });
            });
          }
        }
      });
    },
    checkItems(array, item) {
      var list = [];
      array.forEach((x) => {
        if (x.type == "grade") {
          list.push({
            gradeId: x.nodeId,
            gradeName: x.title,
            studySectionId: x.studySectionId,
          });
        }
      });

      this.selectList = Object.assign([], list);

      this.$emit("gradeSelect", this.selectList);
    },
  },
  watch: {
    studySectionId(val) {
      if (this.studySectionId.length > 0) {
        this.init();
      }
    },
    currentList(val) {
      this.selectList = Object.assign([], this.currentList);
      this.datas.forEach((x) => {
        x.children.forEach((b) => {
          var array = this.selectList.find((a) => a.gradeId == b.nodeId);

          if (array != undefined && JSON.stringify(array) != "{}") {
            console.log(JSON.stringify(array));
            b.checked = true;
          }
        });
      });
    },
  },
};
</script>